const USER_STORAGE_KEY = 'checklist:userName';

const hasSessionStorage = () => {
  if (typeof window === 'undefined') return false;
  try {
    return typeof window.sessionStorage !== 'undefined';
  } catch (error) {
    return false;
  }
};

export const getChecklistUserName = () => {
  if (!hasSessionStorage()) return null;
  return window.sessionStorage.getItem(USER_STORAGE_KEY);
};

export const setChecklistUserName = (name) => {
  if (!hasSessionStorage()) return;
  const sanitized = typeof name === 'string' ? name.trim() : String(name || '').trim();
  if (!sanitized) return;
  window.sessionStorage.setItem(USER_STORAGE_KEY, sanitized);
};

export const clearChecklistUserName = () => {
  if (!hasSessionStorage()) return;
  window.sessionStorage.removeItem(USER_STORAGE_KEY);
};

const userStorage = {
  getChecklistUserName,
  setChecklistUserName,
  clearChecklistUserName,
};

export default userStorage;
